export default {
      id: "check-circle-usage",
      viewBox: "0 0 46 46",
      url: __webpack_public_path__ + "img/icons.svg#check-circle",
      toString: function () {
        return this.url;
      }
    }